import { MainLayout } from "@/layout";
import { medicineInfoRoute, medicineDetailRoute } from "@/config/RouteConfig";

const medicine = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...medicineInfoRoute,
      component: () => import("@/views/MedicineInfo"),
    },
    {
      ...medicineDetailRoute,
      component: () => import("@/views/MedicineDetail"),
    },
  ],
};

export default medicine;